export const appConfig = {
  logo: '/static/lockspace_logo.svg',
  name: 'LockSpace',
};
